const STORAGE_KEY = 'antidote:size-guide-unit';

/**
 * Wraps a size guide (page or product drawer). Switches every guide on the page
 * between cm and inches, remembers the choice, and in the product drawer
 * highlights the size currently selected in the variant picker.
 */
class SizeGuide extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#handleChange);
    this.closest('dialog-component')?.addEventListener('dialog:open', this.#highlightSelectedSize);

    const savedUnit = readUnit();
    if (savedUnit) this.setUnit(savedUnit);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#handleChange);
    this.closest('dialog-component')?.removeEventListener('dialog:open', this.#highlightSelectedSize);
  }

  /** @param {string} unit */
  setUnit(unit) {
    this.dataset.unit = unit;
    for (const input of this.querySelectorAll('.size-guide__units input')) {
      if (input instanceof HTMLInputElement) input.checked = input.value === unit;
    }
  }

  /** @param {Event} event */
  #handleChange = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.closest('.size-guide__units')) return;

    writeUnit(input.value);
    for (const guide of document.querySelectorAll('size-guide')) {
      if (guide instanceof SizeGuide) guide.setUnit(input.value);
    }
  };

  #highlightSelectedSize = () => {
    const picker = document.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
    const fieldset = picker?.querySelector('.size-guide-trigger')?.closest('fieldset');
    const selected = fieldset?.querySelector('input:checked');
    const size = selected instanceof HTMLInputElement ? selected.value : null;

    for (const row of this.querySelectorAll('tbody tr')) {
      if (!(row instanceof HTMLElement)) continue;
      const isSelected = row.dataset.size === size;
      row.classList.toggle('is-selected', isSelected);
      if (isSelected) {
        row.setAttribute('aria-current', 'true');
      } else {
        row.removeAttribute('aria-current');
      }
    }
  };
}

function readUnit() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

/** @param {string} unit */
function writeUnit(unit) {
  try {
    localStorage.setItem(STORAGE_KEY, unit);
  } catch {
    // Storage blocked; the toggle still works for this page view.
  }
}

if (!customElements.get('size-guide')) customElements.define('size-guide', SizeGuide);
